export { default as NotFoundPage } from "./NotFoundPage";
